// Framework loading + selection helpers. Content lives in DynamoDB at runtime
// (seeded from the catalog JSON); these in-process values back tests, the seed
// script, and the default-WAR fallbacks.

import type { FrameworkDefinition, PillarId, Question } from '../types/framework';
import type { Selection } from '../types/review';
import { defaultSelectionFor } from '../types/framework';
import { DEFAULT_FOCUS, frameworks, getFrameworkByFocus } from './catalog';

/** The default WAR (Databricks). Prefer getFrameworkByFocus(focus) for multi-WAR code. */
export const framework: FrameworkDefinition = getFrameworkByFocus(DEFAULT_FOCUS) ?? frameworks[0]!;

/** Default selection for the default WAR: its core pillars (lenses off). */
export const DEFAULT_SELECTION: Selection = { pillars: defaultSelectionFor(framework) };

/** Questions assessed for a given selection: those in a selected pillar. */
export function questionsForSelection(selection: Selection, fw: FrameworkDefinition = framework): Question[] {
  const pillars = new Set<PillarId>(selection.pillars);
  return fw.questions.filter((q) => pillars.has(q.pillarId));
}

/** True if a question id exists and is in-scope for the selection. */
export function isQuestionInSelection(
  questionId: string,
  selection: Selection,
  fw: FrameworkDefinition = framework,
): boolean {
  const q = fw.questions.find((x) => x.id === questionId);
  if (!q) return false;
  return selection.pillars.includes(q.pillarId);
}

export { DEFAULT_FOCUS, frameworks, getFrameworkByFocus, listWars } from './catalog';
export { frameworkSchema } from './schema';
export { EXPECTED_CORE_QUESTIONS, EXPECTED_LENS_QUESTIONS, EXPECTED_TOTAL_QUESTIONS } from './schema';
